import { MasterclassHomeScreen } from '@/modules/masterclass-home';

export default function MasterclassHome() {
  return <MasterclassHomeScreen />;
}
